import React from 'react'
import Section from '@components/layout/Section/Section'
import SectionHeading from '@components/layout/Section/SectionHeading/SectionHeading'
import termsContent from './content/termsContent'
import TextWithHeading from '@components/layout/Section/TextWithHeading/TextWithHeading'

const TermsOfUse = () => (
  <Section>
    <SectionHeading heading="Entrepreneur Seminar Terms of Use" />

    {termsContent.map(({ heading, paragraphs }) => (
      <TextWithHeading key={heading} heading={heading} paragraphs={paragraphs} />
    ))}
  </Section>
)

export default TermsOfUse
